import { createApp } from 'vue'
import App from './App.vue'
import * as CommonServiceInstance from './services/common/CommonServiceInstance.js';
import router from './router/index'
const app = createApp(App);
//createApp(App).mount('#app')


import i18n from './locales/i18n'
import * as CommonFunction from './site.js';
import VueSweetalert2 from 'vue-sweetalert2';



app.config.globalProperties.$CommonFunction = CommonFunction;
const lang = localStorage.getItem('Public_lang') || 'ar-sa';
localStorage.setItem('Public_lang', lang);
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.conditionalRoute)) {
        // this route requires condition to be accessed
        // if not, redirect to home page. 
        if (!checkCondition) {
            //check codition is false
            next({ path: '/' })
        } else {
            //check codition is true
            next()
        }
    } else {
        next() // make sure to always call next()! 
    }
});

document.documentElement.lang = lang;
document.documentElement.dir = lang === 'en-us' ? 'ltr' : 'rtl';
app.config.globalProperties.$HttpClient = CommonServiceInstance;
app.use(i18n);
app.use(router);
app.use(VueSweetalert2);
app.mount("#app");